'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwTextArea = require('./CwTextArea.scss');

var _CwTextArea2 = _interopRequireDefault(_CwTextArea);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwTextArea = function (_Component) {
  (0, _inherits3.default)(CwTextArea, _Component);

  function CwTextArea() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CwTextArea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CwTextArea.__proto__ || (0, _getPrototypeOf2.default)(CwTextArea)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
      if (!_this.props.onChange) {
        return;
      }
      _this.props.onChange(e.target.value);
    }, _this.handleKeyPress = function (e) {
      if (_this.props.isDisabled || !_this.props.onKeyPress) {
        return;
      }
      _this.props.onKeyPress(e);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CwTextArea, [{
    key: 'focus',
    value: function focus() {
      this.textarea.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = {
        wrap: (0, _assign2.default)({
          height: this.props.height,
          minHeight: this.props.minHeight,
          maxHeight: this.props.maxHeight,
          width: this.props.width
        }, this.props.style)
      };

      return _react2.default.createElement('textarea', {
        'data-cwid': this.props.cwId,
        'data-cwdata': "focusable",
        style: styles.wrap,
        className: (0, _classnames2.default)(this.props.className, _CwTextArea2.default.textArea, (0, _defineProperty3.default)({}, _CwTextArea2.default.invalid, this.props.invalid)),
        placeholder: this.props.placeholder,
        readOnly: this.props.readOnly,
        value: this.props.value ? this.props.value : '',
        onChange: this.handleChange,
        onKeyDown: this.props.onKeyDown,
        onClick: this.props.onClick,
        onKeyUp: this.props.onKeyUp,
        onKeyPress: this.handleKeyPress,
        tabIndex: this.props.disabled ? -1 : this.props.tabIndex,
        disabled: this.props.disabled,
        maxLength: this.props.maxLength,
        ref: function ref(input) {
          return _this2.textarea = input;
        },
        autoFocus: this.props.autoFocus,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        rows: this.props.rows
      });
    }
  }]);
  return CwTextArea;
}(_react.Component);

exports.default = CwTextArea;


CwTextArea.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Text in textfield
   */
  value: _propTypes2.default.string,
  /**
   * Hint text, displayed when user has not typed anything in
   */
  placeholder: _propTypes2.default.string,
  /**
   * Used to set text area to a read only mode
   */
  readOnly: _propTypes2.default.bool,
  /**
   * Callback function that is fired when textarea's text changes
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function that is fired when key is pressed while textarea is active
   */
  onKeyPress: _propTypes2.default.func,
  /**
   * Height for textarea
   */
  height: _propTypes2.default.number,
  /**
   * Min Height for textarea
   */
  minHeight: _propTypes2.default.number,
  /**
   * Max Height for textarea
   */
  maxHeight: _propTypes2.default.number,
  /**
   * The maximium number of characters allowed in the field.
   */
  maxLength: _propTypes2.default.number,
  /**
   * Width for textarea
   */
  width: _propTypes2.default.number,
  /**
   * Used to control order when tabbing through items
   */
  tabIndex: _propTypes2.default.number,
  /**
   * Used to control if text is valid
   */
  invalid: _propTypes2.default.bool,
  /**
   * Used to disable textarea
   */
  disabled: _propTypes2.default.bool,
  /**
   * Used to control if textarea is autofocused when the page loads
   */
  autoFocus: _propTypes2.default.bool,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes2.default.func,
  /**
   * Override the styles of the root element
   */
  style: _propTypes2.default.object,
  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes2.default.string,
  /**
   * HTML attribute which specifices the visible height of textarea in lines
   */
  rows: _propTypes2.default.number
};

CwTextArea.defaultProps = {
  tabIndex: 0
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwtextarea/CwTextArea.js
// module id = 859
// module chunks = 10